import { useEffect, useState } from 'react';
import { _getMetaTags } from '@/service/service';

interface UseMetaTypes {
  title: string;
  description: string;
  imageUrl: string;
  isHome: boolean;
}

const useMeta = (routeName) => {
  const [metaTags, setMetaTags] = useState<UseMetaTypes>();

  const sanitizeRouteName = (name) => {
    const sanitizedName = name.replace(/^\/+|\/+$/g, '').trim();
    const segments = sanitizedName.split('/');
    return segments[segments.length - 1];
  };

  const sanitizedRouteName = sanitizeRouteName(routeName);
  useEffect(() => {
    const csrMetaFetcher = async () => {
      try {
        const res = await _getMetaTags(sanitizedRouteName);
        setMetaTags(res);
      } catch (error) {}
    };
    csrMetaFetcher();
    return () => {};
  }, [routeName]);

  return metaTags;
};

export default useMeta;
